'use es6';

import { Fragment } from 'react';
import { connect } from 'react-redux';
import { handleFieldListClick } from 'FormsUI/actions/FormDragDrop';
import { isUngatedForPagination } from 'FormsUI/selectors/Gates';
import FormattedMessage from 'I18n/components/FormattedMessage';
import SectionHeader from '../../../components/editor/leftPanel/common/SectionHeader';
import FieldList from 'FormsUI/components/editor/form/properties/newFields/FieldList';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const langKey = suffix => `editor.form.properties.${suffix}`;
const NewPropertiesContainer = ({
  ungatedForPagination = false,
  handleFieldClick = () => {}
}) => {
  const handleFieldClickArgs = (__, {
    fieldType
  }) => handleFieldClick({
    scroll: true,
    fieldType
  });
  return /*#__PURE__*/_jsx(Fragment, {
    children: /*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsx(SectionHeader, {
        content: /*#__PURE__*/_jsx(FormattedMessage, {
          message: langKey('createNewTab.header')
        })
      }), /*#__PURE__*/_jsx(FieldList, {
        handleClick: handleFieldClickArgs,
        ungatedForPagination: ungatedForPagination
      })]
    })
  });
};
const mapStateToProps = state => ({
  ungatedForPagination: isUngatedForPagination(state)
});
const mapActionsToProps = {
  handleFieldClick: handleFieldListClick
};
export default connect(mapStateToProps, mapActionsToProps)(NewPropertiesContainer);